import type { DirectoryPerson } from '../types';
import { displayedPositions } from '../lib/directoryPositions';

/** The Positions a person holds, comma-separated. A Position that only the roster record holds is marked "roster". Display only. */
export default function PositionList({ person, empty = '—' }: { person: Pick<DirectoryPerson, 'positions' | 'contactPositions'>; empty?: string }) {
  const list = displayedPositions(person);
  if (list.length === 0) return <>{empty}</>;
  return (
    <>
      {list.map((p, i) => (
        <span key={p.name}>
          {i > 0 && ', '}
          {p.name}
          {p.rosterOnly && <span className="subtitle" title="Held on the roster record; not yet recorded as an Org Chart assignment"> (roster)</span>}
        </span>
      ))}
    </>
  );
}
